<template>
  <div class="userCenter">
    <!-- 用户信息区 -->
    <userInfo :users="users" id="userInfo" />
    <!-- 订单信息区 -->
    <orderInfo id="orderInfo" />
    <!-- 下载信息区 -->
    <consumptionHistory :table_height='table_height - 125' />
  </div>
</template>

<script>
  import userInfo from "@/components/user/userInfo.vue";
  import orderInfo from "@/components/payment/orderInfo.vue"
  import consumptionHistory from "@/components/payment/consumptionHistory.vue"
  export default {
    name: "userCenter",
    props: {
      table_height: Number
    },
    computed: {
      // 订单信息
      order() {
        return this.$store.state.order;
      },
      // 用户及账号信息
      users() {
        return this.$store.state.users;
      }
    },
    components: {
      userInfo,
      orderInfo,
      consumptionHistory
    }
  }
</script>

<style scoped>

</style>